import React, {Component} from "react";
import {Alert, Button, Col, Container, Form, Row} from "react-bootstrap";
import "./login.scss";
import {connect} from "react-redux";
import {getLogin} from "../../redux/actions/auth";
import {saveState} from "../../LocalStore/localStorage";
import {brandLogo} from "../../utils/Constants";
import {Link} from "react-router-dom";
import {forgotPassword, createAccount} from "../../utils/routes";
import {accessLogSend} from "../../redux/actions/instructor";

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                instructor_id: "",
                password: ""
            },
            errors: ""
        };
    }

    changeInput = e => {
        const data = {...this.state.data};
        data[e.target.id] = e.target.value;
        this.setState({data});
    };

    submitLogin = async e => {
        e.preventDefault();
        const {instructor_id, password} = this.state.data;
        if (instructor_id === "" || password === "") {
            this.setState({errors: "User ID and password field required!"});
            setTimeout(() => this.setState({errors: ""}), 3000);
        } else {
            await this.props.dispatch(getLogin(instructor_id, password));
            if (this.props.login && Object.keys(this.props.login).length > 0) {

                if (this.props.login.data && this.props.login.data.message) {
                    this.setState({errors: "User ID or password Invalid!"});
                } else {
                    await saveState('userInfo', this.props.login);
                    const {id, instructor_id, first_name, last_name, mobile_number} = this.props.login;
                    await this.props.dispatch(accessLogSend(`${id}|#|${instructor_id}|#|${first_name} ${last_name}|#|${mobile_number}`, 'Login Done'));
                    window.location = "/";
                }

            }
        }
    };

    render() {
        const {instructor_id, password} = this.state.data;
        const {errors} = this.state;

        return (
            <div className="loginBody">
                <div className="login-container">
                    <div>
                        <div className="login-wrap p-l-85 p-r-85 p-t-55 p-b-55">
                            <div className="admin-title p-b-32">
                                <div className="text-center loginLogo">
                                    <a href="/"><img src={brandLogo} alt="logo"/></a>
                                </div>
                                <br/>
                                <h2 className="text-center">Admin login</h2>
                            </div>
                            <Form onSubmit={e => this.submitLogin(e)}>
                                {errors && (
                                    <Alert key={1} variant="danger">
                                        {errors}
                                    </Alert>
                                )}
                                <Form.Group controlId="instructor_id">
                                    <Form.Label>User Id</Form.Label>
                                    <Form.Control
                                        onChange={this.changeInput}
                                        value={instructor_id || ""}
                                        type="instructor_id"
                                        className="input"
                                        placeholder="Enter user id"
                                        autoComplete="off"
                                    />
                                </Form.Group>

                                <Form.Group controlId="password">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        onChange={this.changeInput}
                                        value={password || ""}
                                        className="input"
                                        type="password"
                                        placeholder="Password"
                                    />
                                </Form.Group>

                                <Form.Group className=" m-t-42 d-flex align-items-center justify-content-between"
                                            style={{marginBottom: "0"}}>
                                    <label htmlFor="rememberme"><input name="rememberme" type="checkbox" id="rememberme"
                                                                       value="forever"/> Remember Me</label>
                                    <Button
                                        className="login-btn"
                                        variant="primary"
                                        type="submit"
                                    >
                                        Submit
                                    </Button>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className="p-l-85 p-r-85 m-t-42 d-flex align-items-center justify-content-between">
                            <Link to={forgotPassword}>Forgot your password?</Link>
                            {/* <Link to={createAccount}>Create Account</Link> */}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    login: state.login,
});
export default connect(mapStateToProps)(Login);
